//@ts-nocheck

'use client'

import React from 'react'
import Image from 'next/image'
import { CtaTypes } from '../../../types/Cta'
import { SpacerBase } from '../../atoms/GridSystem'
import { Paragraph } from '../../atoms/Typography/Typography.component'
import Button from '../../atoms/Button/Button.component'

import { useModal } from '../../../contexts/Modal.context'
import { ColorSchemeTypes } from '../../../types/ColorScheme'

import * as S from './CardFeatures.styles'

interface ImageType {
  src: string
  alt: string
  fill?: boolean
}

interface ModalType {
  title: string
  description: string
}

interface CardFeaturesProps {
  type: 'FeatureListInformative' | 'FeatureListIconic' | 'FeatureListIllustrative' | 'FeatureListStatistic' | 'FeatureBannerWithList'
  image?: ImageType
  preTitle?: string
  title?: string
  subtitle?: string
  cta?: CtaTypes
  modal?: ModalType
  isLast?: boolean
  colorScheme?: ColorSchemeTypes
  withBackground?: boolean
  buttonNoHorizontalPadding?: boolean
}

const CardFeatures: React.FC<CardFeaturesProps> = ({
  type,
  image,
  preTitle,
  title,
  subtitle,
  cta,
  modal,
  isLast,
  colorScheme,
  withBackground,
  buttonNoHorizontalPadding = true
}) => {
  const { showModal } = useModal()

  const showModalHandler = () => {
    return
    // showModal(ModalNewsletter, { modal })
  }

  return (
    <S.CardFeatures colorScheme={colorScheme} withBackground={withBackground}>
      {image ? (
        type == 'FeatureListIllustrative' ? (
          <>
            <S.CardFeaturesImage>
              <Image
                src={image?.url}
                alt={image?.alt}
                fill
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 75vw, 50vw"
              />
            </S.CardFeaturesImage>
            <SpacerBase xs={2} />
          </>
        ) : (
          <>
            <Image
              {...image}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 75vw, 50vw"
            />
            <SpacerBase xs={2} />
          </>
        )
      ) : null}
      {preTitle ? (
        <>
          <Paragraph
            typo="label"
            content={preTitle}
            weight="medium"
            uppercase
          />
          <SpacerBase xs={1} />
        </>
      ) : null}
      {title ? (
        <>
          <Paragraph
            typo={(type == 'FeatureListStatistic' || type == 'FeatureBannerWithList') ? 'headingXXL' : 'headingMD'}
            content={title}
            weight="medium"
          />
          <SpacerBase xs={2} />
        </>
      ) : null}
      {subtitle ? (
        <>
          <Paragraph
            typo={(type == 'FeatureBannerWithList') ? 'paragraphLG' : 'paragraphMD'}
            content={subtitle}
          />
          {isLast ? null : <SpacerBase xs={2} />}
        </>
      ) : null}
      {cta ? (
        <Button
          {...cta}
          variant="secondary"
          iconEnd="arrow-right"
          noHorizontalPadding={buttonNoHorizontalPadding}
        />
      ) : null}
    </S.CardFeatures>
  )
}

export default CardFeatures
